import { render, staticRenderFns } from "./AboutTA6.vue?vue&type=template&id=7fba0cd3&scoped=true&"
import script from "./AboutTA6.vue?vue&type=script&lang=js&"
export * from "./AboutTA6.vue?vue&type=script&lang=js&"
import style0 from "./AboutTA6.vue?vue&type=style&index=0&id=7fba0cd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fba0cd3",
  null
  
)

export default component.exports